import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import styles from "@/styles/components/ProtectedRoute.module.css";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, isAuthenticated, loading } = useAuth();
  if (loading)
    return (
      <div className={styles.loading}>
        Laden...
      </div>
    );
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (requiredRole) {
    const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!roles.includes(user?.role)) return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
